<template>
  <RouterLink
    :to="{
      name: backToRoute,
      params: { routeParams },
    }"
    class="btn btn-outline-primary border-2 p-0 d-flex align-items-center justify-content-center back-button me-3"
  >
    <BasePortalIcon class="rotate rotate--180" icon="caret" />
  </RouterLink>
</template>

<script lang="ts" setup>
defineProps({
  backToRoute: {
    type: String,
    required: true,
  },
  routeParams: {
    type: String,
    default: undefined,
  },
})
</script>

<style lang="scss" scoped>
.back-button {
  width: 30px;
  min-width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 1rem;

  > svg {
    margin-right: 2px !important;
  }
}
</style>
